export const DEFAULT_PARAMS = {
    N: 1 << 15,
    p: 1,
    r: 8
};
